import { AddBulkEmployees } from '../../pages';
import { EmployeeController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import { useFileUpload } from 'use-file-upload';
import { object, string } from 'yup';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

const AddBulkEmployeesContainer = ({ closeModal, setShowSurvey }) => {
	const [loading, setLoading] = useState(false);
	const [uploaded, setUploaded] = useState(false);
	const [file, selectFile] = useFileUpload();

	const { needFeedback } = useGetAllActiveReviews(constant.FEEDBACK.EMPLOYEEADDBULK);

	const selectClick = () => {
		selectFile({ accept: '.xlsx' });
	};

	const uploadClick = async payload => {
		delete payload.departmentName;
		delete payload.employeeGroupName;

		const formData = new FormData();
		for (const [key, value] of Object.entries(payload)) {
			if (value !== '') {
				formData.append(key, value);
			}
		}
		setLoading(true);
		let fileToSend;

		if (typeof file.source === 'string') {
			fileToSend = await fetch(file.source)
				.then(response => response.blob())
				.then(
					blob =>
						new File([blob], 'name', {
							type: blob.type,
							lastModified: new Date(),
						})
				);
		}
		formData.append('employees', fileToSend);
		const { status, errorMessage } =
			await EmployeeController.createBulkEmployees(formData);
		if (status === constant.Success) {
			setUploaded(true);
		} else {
			MimaToastUtil.error({
				message: errorMessage,
			});
		}
		setLoading(false);
	};
	const validationSchema = () =>
		object({
			settlementCycle: string().required('Settlement Cycle is required'),
		});

	return (
		<AddBulkEmployees
			closeModal={closeModal}
			validationSchema={validationSchema}
			uploaded={uploaded}
			uploadClick={uploadClick}
			file={file}
			selectClick={selectClick}
			loading={loading}
			needFeedback={needFeedback}
			setShowSurvey={setShowSurvey}
		/>
	);
};

export default observer(AddBulkEmployeesContainer);
